module.exports = {
	"id": "GF",
	"name": "French Guiana",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": 0.006259,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.006259,
			"12": 0.012518,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.100144,
			"19": null,
			"20": null,
			"21": 0.012518,
			"22": 0.012518,
			"23": 0.006259,
			"24": null,
			"25": null,
			"26": 0.006259,
			"27": null,
			"28": null,
			"29": 0.025036,
			"30": null,
			"31": 0.012518,
			"32": null,
			"33": 0.012518,
			"34": 0.068849,
			"35": 0.006259,
			"36": 0.006259,
			"37": null,
			"38": 0.018777,
			"39": 0.143957,
			"40": 0.012518,
			"41": null,
			"42": 0.025036,
			"43": 0.100144,
			"44": 0.056331,
			"45": 0.363022,
			"46": 0.018777,
			"47": 0.018777,
			"48": 0.081367,
			"49": 0.788634,
			"50": 0.081367,
			"51": 0.244101,
			"52": 0.607123,
			"53": 22.044198,
			"54": 6.647058,
			"55": 0.025036,
			"56": 0.006259,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.006259,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": 0.012518,
			"16": 0.012518,
			"17": 0.012518,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.012518,
			"25": 0.018777,
			"26": 0.006259,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.012518,
			"31": 0.025036,
			"32": null,
			"33": null,
			"34": 0.018777,
			"35": 0.018777,
			"36": null,
			"37": 0.118921,
			"38": 0.106403,
			"39": 0.018777,
			"40": 0.018777,
			"41": 0.025036,
			"42": 0.056331,
			"43": 0.137698,
			"44": 0.037554,
			"45": 0.093885,
			"46": 0.056331,
			"47": 0.575828,
			"48": 0.801152,
			"49": 11.685553,
			"50": 0.031295,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.006259
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.012518,
			"32": null,
			"33": null,
			"34": 0.181511,
			"35": null,
			"36": 0.018777,
			"37": 0.025036,
			"38": null,
			"39": null,
			"40": 0.275396,
			"41": 0.050072,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.018777
		},
		"safari": {
			"0": null,
			"4": 0.012518,
			"5": 0.031295,
			"6": null,
			"7": 0.031295,
			"8": 0.081367,
			"9": 0.137698,
			"10": 1.796333,
			"3.1": null,
			"3.2": null,
			"5.1": 0.112662,
			"6.1": 0.037554,
			"7.1": null,
			"9.1": 0.882519
		},
		"ios_saf": {
			"8": 0,
			"10": 3.19240893922,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0860317268943,
			"8.1-8.4": 0.158939970025,
			"9.0-9.2": 0.075824572856,
			"9.3": 1.15681079101
		},
		"android": {
			"3": 0,
			"4": 0.0456872093023,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00571090116279,
			"4.1": 0.164800290698,
			"4.2-4.3": 0.412000726744,
			"4.4": 0.94474622093,
			"4.4.3-4.4.4": 0.952904651163
		},
		"ie": {
			"6": null,
			"7": 0.0207740350195,
			"8": 0.38778198703,
			"9": 0.193890993515,
			"10": 0.318535203632,
			"11": 4.4179447808,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0399990238621,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00111108399617
		},
		"edge": {
			"12": 0.237842,
			"13": 0.93885,
			"14": 2.297053
		},
		"ie_mob": {
			"10": 0.0383686760563,
			"11": 0.156215323944
		},
		"bb": {
			"7": 0.0102905,
			"10": null
		},
		"samsung": {
			"0": 5.541902
		},
		"and_uc": {
			"0": 0.258198
		},
		"op_mini": {
			"0": 0.538899892142
		},
		"and_chr": {
			"0": 27.081736
		},
		"and_ff": {
			"0": 0.041162
		}
	},
	"total": 98.9246785
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GF.json
 ** module id = 528
 ** module chunks = 0
 **/